import React from 'react'

import FormError from "../../../../../../../core/gd-form/common/form-error/form-error"
import FormManager from "../../../../../../../core/gd-form/common/form-manager"
import FormSelect from "../../../../../../../core/gd-form/form-element/select-new/select-new"
import {ProjectSystemType} from "../../../../../../../core/model2/project/types"
import {ViewTypeConfigs} from "../../../../../../../core/gd/const/views/view-type-config"
import project_getDefaultViewTypes from "./functions/get-default-view-types"

type Props = {
    form       : FormManager
    systemType : ProjectSystemType
}

export default function FormDefaultViewSelector(props: Props) {
    const defaultViewTypes = project_getDefaultViewTypes(props.systemType)
    const defaultViewsOptions = _.map(defaultViewTypes, viewType=>{
        const viewTypeConfig = ViewTypeConfigs[viewType]
        return {
            icon    : viewTypeConfig?.icon,
            label   : viewTypeConfig?.name,
            value   : viewType
        }
    })

    return (
        <div className="row">
            <div className="label">Default view</div>
            <div className="element">
                <FormSelect size        = "big"
                            renderValue = 'icon-text'
                            options     = {defaultViewsOptions}
                            name        = "defaultView"
                            form        = {props.form}/>
                <FormError form={props.form} name="defaultView"/>
            </div>
        </div>
    )
}
